import { post, put } from '../../api-config';
import { gdpService } from './_service';

export const postAuthUser = async (data: any) => await post(gdpService, '/doLogin', data);
export const postAuthUserForgotPassword = async (params: any) => await post(gdpService, '/forgotPassword', null, params);
export type IdpProvider = 'msal' | 'google';

const idpLoginPath: Record<IdpProvider, string> = {
  msal: '/doLogin/microsoft',
  google: '/doLogin/google',
};

export const postAuthUserIdp = async (provider: IdpProvider, params: { bearer: string }) =>
  await post(gdpService, idpLoginPath[provider], null, params);

export const postAuthUserIdpSelect = async (
  provider: IdpProvider,
  params: { bearer: string; userId: string },
) => await post(gdpService, `${idpLoginPath[provider]}/select`, null, params);
export const postLogoutUser = async () => await post(gdpService, '/doLogout');
export const postPassword = (data: any) => post(gdpService, `/password`, data, null);
export const putVerifyEmail = (params: any) => put(gdpService, `/verifyEmail`, null, params);
export const putPushToken = (data: any) => put(gdpService, `/pushToken`, data, null);
